import { Deserializable } from '../../protocols/deserializable';
import { Gender } from '../../types/dto/gender';
import { Pronoun } from './pronoun';
import * as moment from 'moment';

export class MemberPersonalInformation implements Deserializable {
  public birthDate!: string;
  public socialInsuranceNumber!: string;
  public pronounId!: number;
  public genderId!: number;
  public gender!: Gender;
  public pronoun!: Pronoun;

  // Not From API
  public formattedBirthDate!: string;

  onDeserialize(): void {
    if (!!this.birthDate) {
      const date = moment(this.birthDate.toString().split('T')[0]);
      this.formattedBirthDate = date.format('DD / MM / YYYY');
    }
    if (!!this.gender) {
      this.gender = window.injector.Deserialize.instanceOf(Gender, this.gender);
    }
    if (!!this.pronoun) {
      this.pronoun = window.injector.Deserialize.instanceOf(Pronoun, this.pronoun);
    }
  }
}
